import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';

const paperStyles = {
  borderRadius: 0.5,
  boxShadow: 3,
  display: 'flex',
  flexDirection: 'column',
  px: 4,
  py: 3,
  width: 278,
};

const FiltersDropdown = ({ children, ...forwardedProps }) => {
  return (
    <Popover
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      {...forwardedProps}
      slotProps={{
        paper: { sx: paperStyles },
      }}
    >
      <Stack spacing={2}>{children}</Stack>
    </Popover>
  );
};

FiltersDropdown.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FiltersDropdown;
